import { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import {
  getTransactionEffect,
  getKeyDatesEffect,
  getTransactionAgentsCoordinators,
} from 'store/effects/transactions';
import {
  requestGetAgentCoordinatorRelatedContactsEffect,
  requestGetTransactionRelatedContactsEffect,
} from 'store/effects/relatedContacts';
import { getTransactionRolesEffect } from 'store/effects';
import { getTransactionSelector } from 'store/selectors/transaction';
import { getTransactionDetailsEffect } from 'store/effects/transactions';
import { requestGetProjectCategories } from 'store/effects/projects';
import { PageWrapper, AsideNavigation, Content } from 'components/Transactions';
import { TransactionView } from './components';
import { isTransactionEmpty } from '../helper';

import styles from './styles.module.scss';

const TransactionOverview = (props) => {
  const { className, match } = props;
  const { transaction, isError, status, isPending, isIdle } = useSelector(getTransactionSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isTransactionEmpty(transaction, ['Participants', 'Tasks', 'Milestones'])) {
      dispatch(
        getTransactionEffect({
          id: match.params.id,
          include: 'milestones,participants,tasks,transactioncommission',
        }),
      );
    }

    dispatch(getKeyDatesEffect({ transactionId: match.params.id }, { silent: !isIdle }));
    dispatch(getTransactionAgentsCoordinators(match.params.id, { silent: !isIdle }));
    dispatch(getTransactionRolesEffect());

    // Fetching related contacts
    dispatch(requestGetAgentCoordinatorRelatedContactsEffect({ includeAgents: true }));

    // Fetching related contacts specific to transaction
    dispatch(requestGetTransactionRelatedContactsEffect({ transactionId: match.params.id }));

    dispatch(getTransactionDetailsEffect({ id: match?.params?.id }));
    dispatch(requestGetProjectCategories({}, { silent: true }));
  }, []);

  return (
    <div className={classNames(styles.transactionOverview, className)}>
      <PageWrapper notFound={isError && status === 404} unAuthorized={isError && status === 401}>
        <AsideNavigation />
        <Content isPending={isPending} bgGray>
          <TransactionView />
        </Content>
      </PageWrapper>
    </div>
  );
};

TransactionOverview.propTypes = {
  className: PropTypes.string,
  match: ReactRouterPropTypes.match.isRequired,
};

TransactionOverview.defaultProps = {
  className: '',
};

export default TransactionOverview;
